import { Play } from "./styles";
import { useTheme } from "styled-components";
import Icon from "../../../Icon";
import PlayEmptyIcon from "../../../../assets/icons/icon-cool/outline/Arrows-chevron/Right.svg";


const Component = () => {
  const theme = useTheme() as { [key: string]: { [key: string]: string } };

  return (
    <Play>
      <Icon icon={PlayEmptyIcon} size="16px" color={theme.colors.Primary} />
    </Play>
  );
};

export default Component;
